import { useState } from "react";

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-search-eye-line text-2xl" aria-hidden="true"></i>
      </span>
      <h3 className="text-base font-medium text-foreground-900">{title}</h3>
      <p className="max-w-md text-sm text-foreground-500">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}